export default __webpack_public_path__ + "static/media/SET_BG2.02664c01.jpg";